export default __webpack_public_path__ + "static/mustard-seo-3001369d77f74441c4210e934c36bab5.webp";